import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import { Card } from '../components/ui/card';
import { Fuel } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

function ReviewAccess() {
  const { secret } = useParams();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    const authenticateReview = async () => {
      try {
        const res = await axios.get(`${API}/api/auth/review-access/${secret}`);
        
        if (res.data.token && res.data.user) {
          // Store review mode flag
          localStorage.setItem('reviewMode', 'true');
          
          // Login with the received token
          login(res.data.token, res.data.user);
          
          setStatus('success');
          
          // Redirect to dashboard after brief delay
          setTimeout(() => {
            navigate('/');
          }, 1500);
        }
      } catch (err) {
        setStatus('error');
        setError('Invalid or expired review link');
      }
    };

    if (secret) {
      authenticateReview();
    } else {
      setStatus('error');
      setError('Invalid review link');
    }
  }, [secret, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-blue-700 p-4">
      <Card className="w-full max-w-md p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center shadow-lg border border-border/30">
            <img src="https://customer-assets.emergentagent.com/job_f33e49fe-e820-4c95-aab4-40ccc87efe18/artifacts/dtk4fxv6_Fuelogic%20White%20Background%20Logo%20dark%20greay.jpg" alt="Logo" className="w-16 h-16 object-contain rounded-lg" />
          </div>
        </div>
        
        <h1 className="font-heading font-bold text-2xl mb-2 text-foreground">Review Access Portal</h1>
        <p className="text-muted-foreground text-sm mb-6">Secure access verification</p>

        {status === 'loading' && (
          <div className="space-y-4">
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
            </div>
            <p className="text-muted-foreground">Authenticating review access...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <div className="flex justify-center">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <p className="text-emerald-600 font-medium">Access granted!</p>
            <p className="text-muted-foreground text-sm">Redirecting to dashboard...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <div className="flex justify-center">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
            </div>
            <p className="text-red-600 font-medium">{error}</p>
            <p className="text-muted-foreground text-sm">Please contact the administrator for access.</p>
          </div>
        )}
      </Card>
    </div>
  );
}

export default ReviewAccess;
